import * as z from 'zod/mini'

/** Field rules for an uploaded image, shared by the forms, the HTTP bodies and the domain operation. */
export const imageFields = {
  /** What the image shows, for a screen reader. `''` falls back to the premise's or the activity's name. */
  alt: z.string().check(z.trim(), z.maxLength(200)),
}
